export const ENV = process.env.REACT_APP_ENV
export const REK = process.env.REACT_APP_REK
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY
export const ELEVENLABS_API_KEY = process.env.REACT_APP_TEXT_TO_VOICE_EVENLABS_KEY
export const PIXEL_ACCESS_TOKEN = process.env.REACT_APP_PIXEL_ACCESS_TOKEN
export const PIXEL_ID = process.env.REACT_APP_PIXEL_ID
export const API_XANO_BASE_URL = process.env.REACT_APP_XANO_BASE_URL
